import axios from 'axios';
import '../global';

export const SHOW_ATTENDANCE = 'SHOW_ATTENDANCE';
export const ATTENDANCE_LIST = 'ATTENDANCE_LIST';
export const FIRM_INFO = 'FIRM_INFO';
export const MEETING_MATERIALS = 'MEETING_MATERIALS';
export const ROLL_CALL_STATUS = 'ROLL_CALL_STATUS';
export const SHOW_ALL_COMPANIES = 'SHOW_ALL_COMPANIES';
export const EMAIL_ERROR = 'EMAIL_ERROR';
export const COMMITTEE_PARTICIPANT = 'COMMITTEE_PARTICIPANT';
export const EXPIRED_TOKEN = 'EXPIRED_TOKEN';

export function submit_email( email ) {
	return ( dispatch ) => {
		dispatch( check_for_isda_account( email ) );
	};
}

export function check_for_isda_account( email ) {
	return ( dispatch ) => {
		var meet_id = getMeetingInfo().meet_id;
		const url = `${wpApiSettings.root}isda/v1/committees/verify-email?meet_id=${meet_id}`;
		const params = [];
		params[ 'email' ] = email;
		params[ 'ccodes' ] = getAllCcodes();
		axios.post( url, serialize( params ), get_api_config() ).then( response => {
			dispatch( {
				          type   : COMMITTEE_PARTICIPANT,
				          payload: response.data.committee_participant
			          } );

			if ( typeof response.data.companies !== 'undefined') {
				let payload = {
					data: response.data.companies, email: email
				};
				dispatch( {
					          type: SHOW_ALL_COMPANIES, payload: payload
				          } );
			} else if ( typeof response.data.email === 'undefined') {
				dispatch( {
					          type: EMAIL_ERROR, payload: true
				          } );
			} else {
				dispatch( log_isda_information_to_icms( response.data ) );
			}
		} );
	};
}

export function set_email_error( value ) {
	return ( dispatch ) => {
		dispatch( { type: EMAIL_ERROR, payload: value } );
	};
}

export function log_isda_information_to_icms( response_data ) {
	return ( dispatch ) => {
		var meet_id = getMeetingInfo().meet_id;
		const url = `${getCommitteeRollCallUrl()}/roll-call/admission?meet_id=${meet_id}`;
		axios.post( url, serialize( response_data ), get_api_config() )
		     .then( response => {
			     //TODO do error handling here.
			     if ( response.status === 200 ) {
				     dispatch( {
					               type: SHOW_ATTENDANCE, payload: true
				               } );
				     dispatch( {
					               type: FIRM_INFO, payload: response_data
				               } );
			     }
		     } );
	};
}

export function get_attendance_list() {
	return ( dispatch ) => {
		var meet_id = getMeetingInfo().meet_id;
		const url = `${getCommitteeRollCallUrl()}/roll-call/attendance-list?meet_id=${meet_id}`;
		axios.get( url, get_api_config() ).then( response => {
			//TODO do error handling here.
			if ( response.status === 200 ) {
				dispatch( {
					          type: ATTENDANCE_LIST, payload: response.data.attendance
				          } );
			}
		} ).catch(error => {
			dispatch( {
				          type: EXPIRED_TOKEN, payload: true
			          } );
		} );
	};
}

export function get_documents_for_meeting() {
	return ( dispatch ) => {
		var meet_id = getMeetingInfo().meet_id;
		const url = `${getCommitteeRollCallUrl()}/roll-call/documents?meet_id=${meet_id}`;
		axios.get( url, get_api_config() ).then( response => {
			if ( response.status === 200 ) {
				dispatch( {
					          type: MEETING_MATERIALS, payload: response.data
				          } );
			}
		} );
	};
}

export function download_document( file_name, download_file_name ) {
	//TODO ADD LOADING TO THE DOCUMENT
	return ( dispatch ) => {
		var meet_id = getMeetingInfo().meet_id;
		const url = `${getCommitteeRollCallUrl()}/roll-call/documents/download?meet_id=${meet_id}`;
		const urlParams = {};
		const config = get_api_config();
		urlParams[ 'file_name' ] = file_name;
		urlParams[ 'download_file_name' ] = download_file_name;
		const payload = serialize( urlParams );
		//			dispatch(documentLoading(file_name));
		axios.post( url, payload, config )
		     .then( response => location.href = response.data );
	};
}

export function check_roll_call() {
	return ( dispatch ) => {
		var meet_id = getMeetingInfo().meet_id;
		const url = `${getCommitteeRollCallUrl()}/roll-call/status?meet_id=${meet_id}`;
		const config = get_api_config();
		axios.get( url, config ).then( response => dispatch( {
			                                                     type   : ROLL_CALL_STATUS,
			                                                     payload: response.data
		                                                     } ) );
	};
}

function get_api_config() {
	let config = {
		headers: {
			'Authorization': 'Bearer ' + getToken()
		}

	};
	return config;
}

function serialize( obj ) {
	var str = [];
	for ( var p in obj ) {
		if ( obj.hasOwnProperty( p ) ) {
			str.push( encodeURIComponent( p ) + '=' + encodeURIComponent( obj[ p ] ) );
		}
	}
	return str.join( '&' );
}


